export default __webpack_public_path__ + "static/media/c399787ddd26ecc49f7e0094b8b87978.png";